<div class="inner-page-header py-5 text-white">
  <div class="container px-lg-5">
    <h1 class="display-5 fw-bold text-uppercase mb-2">Ensuring Wellness and Safety at Shah Satnam Ji Girls’ College</h1>
    <p class="lead mb-0 text-orange-light">Secure Campus, Confident Future.</p>
  </div>
</div>

<div class="container px-lg-5 py-5">
  <div class="row g-5 align-items-center">
    <div class="col-12 col-lg-8">
      <div class="content-card p-4 p-md-5 shadow-sm rounded-4 bg-white border-top border-5 border-success">
        <h3 class="fw-bold mb-4 text-success border-bottom pb-2">
          <i class="fa-solid fa-shield-halved me-2"></i> Safety and Security
        </h3>
        
        <p class="lead text-muted mb-0" style="line-height: 1.8; text-align: justify;">
          At Shah Satnam Ji Girls’ College (SSG), the safety and security of our students are our top priority. From the moment they step through our gates, students are enveloped in a secure and welcoming environment. Our dedicated team of watchmen and security guards is always on duty, ready to respond swiftly to any concerns or incidents that may arise.
        </p>
      </div>
    </div>

    <!-- Right Side Accent Box -->
    <div class="col-12 col-lg-4">
      <div class="focus-card p-4 shadow-lg rounded-4 text-white text-center d-flex flex-column justify-content-center" style="background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%); min-height: 250px;">
        <div class="shield-icon mb-3"><i class="fa-solid fa-lock text-white"></i></div>
        <h4 class="fw-bold mb-1">Safety First</h4>
        <p class="text-orange-light small mb-0">Dedicated security guard watchmen active 24/7 on campus.</p>
      </div>
    </div>
  </div>

  <!-- Gallery Section -->
  <h3 class="fw-bold text-success mt-5 mb-4 text-uppercase border-bottom pb-2">
    <i class="fa-solid fa-camera me-2"></i> Safety & Security Gallery
  </h3>

  <div class="row g-3">
    <div class="col-6 col-md-3" *ngFor="let img of securityImages">
      <div class="rounded-4 overflow-hidden shadow-sm border border-2 border-white">
        <img [src]="img" alt="Safety & Security" class="img-fluid w-100" style="object-fit: cover; height: 200px;">
      </div>
    </div>
  </div>
</div>
